import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=a01bcf54&"
import script from "./Sort.vue?vue&type=script&lang=ts&"
export * from "./Sort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports